import { render } from "./PanelRightProperty.vue?vue&type=template&id=00140cf5"
import script from "./PanelRightProperty.vue?vue&type=script&lang=js"
export * from "./PanelRightProperty.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__